// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"168":"positioning","769":"layouts"}[chunkId] + "." + {"168":"f3527624","769":"ea97ce0c"}[chunkId] + ".css";
};